import { Archive } from "lucide-react";

const StorageOverview = ({ t, styles, storageStats, documents, theme }) => {
  return (
<div style={{ ...styles.card1, marginTop: "-45px" }}>      <h3 style={styles.cardTitle}>
        <Archive size={28} />
        {t.storageOverview}
      </h3>

      <div style={styles.statsGrid}>
        {/* Used Storage */}
        <div
          style={styles.statCard}
          
        >
          <div style={styles.statValue}>{storageStats.used} MB</div>
          <div style={styles.statLabel}>{t.usedStorage}</div>
        </div>

        {/* Total Files */}
        <div
          style={styles.statCard}
          // onMouseEnter={(e) => {
          //   e.currentTarget.style.transform = "translateY(-4px)";
          //   e.currentTarget.style.boxShadow =
          //     theme === "dark"
          //       ? "0 20px 50px rgba(0, 0, 0, 0.5), 0 10px 25px rgba(59, 130, 246, 0.3)"
          //       : "0 20px 50px rgba(0, 0, 0, 0.12), 0 10px 25px rgba(59, 130, 246, 0.15)";
          // }}
          // onMouseLeave={(e) => {
          //   e.currentTarget.style.transform = "translateY(0)";
          //   e.currentTarget.style.boxShadow =
          //     theme === "dark"
          //       ? "0 15px 40px rgba(0, 0, 0, 0.4), 0 8px 20px rgba(59, 130, 246, 0.2)"
          //       : "0 15px 40px rgba(0, 0, 0, 0.08), 0 8px 20px rgba(59, 130, 246, 0.1)";
          // }}
        >
          <div style={styles.statValue}>{documents.length}</div>
          <div style={styles.statLabel}>{t.totalFiles}</div>
        </div>

        {/* Storage Used % */}
        <div
          style={styles.statCard}
          // onMouseEnter={(e) => {
          //   e.currentTarget.style.transform = "translateY(-4px)";
          //   e.currentTarget.style.boxShadow =
          //     theme === "dark"
          //       ? "0 20px 50px rgba(0, 0, 0, 0.5), 0 10px 25px rgba(59, 130, 246, 0.3)"
          //       : "0 20px 50px rgba(0, 0, 0, 0.12), 0 10px 25px rgba(59, 130, 246, 0.15)";
          // }}
          // onMouseLeave={(e) => {
          //   e.currentTarget.style.transform = "translateY(0)";
          //   e.currentTarget.style.boxShadow =
          //     theme === "dark"
          //       ? "0 15px 40px rgba(0, 0, 0, 0.4), 0 8px 20px rgba(59, 130, 246, 0.2)"
          //       : "0 15px 40px rgba(0, 0, 0, 0.08), 0 8px 20px rgba(59, 130, 246, 0.1)";
          // }}
        >
          <div style={styles.statValue}>{storageStats.percentage}%</div>
          <div style={styles.statLabel}>{t.storageUsed}</div>
        </div>
      </div>

      {/* Progress Bar */}
      <div style={styles.progressBarContainer}>
        <div style={styles.progressBar(storageStats.percentage)} />
      </div>

      <div style={styles.progressText}>
        <span>{storageStats.used} MB {t.used}</span>
        <span>{storageStats.total} MB {t.total}</span>
      </div>
    </div>
  );
};

export default StorageOverview;